<template>
  <v-card class="dashboard-card flex-grow-1 ma-0" outlined>
    <div class="align-baseline d-flex dashboard-card__cabecalho flex-wrap justify-space-between">
      <div class="dashboard-card__titulo">{{ titulo }}</div>
      <slot name="meta" />
    </div>

    <div v-if="carregando" class="align-center d-flex dashboard-estado justify-center">
      <v-progress-circular color="primary" indeterminate size="24" />
    </div>

    <div v-else-if="erro" class="align-center d-flex dashboard-estado dashboard-estado--erro justify-center">
      Não foi possível carregar este gráfico.
    </div>

    <div v-else-if="indisponivel" class="align-center d-flex dashboard-estado justify-center">
      {{ motivo }}
    </div>

    <div v-else-if="vazio" class="align-center d-flex dashboard-estado justify-center">Sem dados para o filtro selecionado</div>

    <highcharts v-else :options="opcoes" />
  </v-card>
</template>

<script>
  export default {
    name: 'GraficoDashboard',

    props: {
      titulo: { type: String, required: true },
      carregando: { type: Boolean, default: false },
      erro: { type: Boolean, default: false },
      indisponivel: { type: Boolean, default: false },
      motivo: { type: String, default: '' },
      vazio: { type: Boolean, default: false },
      opcoes: { type: Object, default: () => ({}) }
    }
  };
</script>

<style scoped>
  .dashboard-card {
    border-color: #e2e6eb !important;
    box-shadow: none !important;
    padding: 20px !important;
  }

  .dashboard-card__cabecalho {
    gap: 8px;
    margin-bottom: 16px;
  }

  .dashboard-card__titulo {
    color: #17202a;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.3;
  }

  .dashboard-estado {
    color: #4f5a67;
    font-size: 13px;
    min-height: 120px;
    text-align: center;
  }

  .dashboard-estado--erro {
    color: #d14343;
  }
</style>
